// extracted by mini-css-extract-plugin
export default {"container":"xFGBh_container","page-container":"qHyKa_page-container"};